import Vue from "vue";
import Vuex from "vuex";
import me from "../store/modules/me";
import baileys_integration from "./modules/baileys_integration";
import configs from "../store/modules/configs";
import users from "../store/modules/users";
import channels from "../store/modules/channels";
import leads from "../store/modules/leads";
import customfield from "../store/modules/customfields";
import interests from "../store/modules/interests";
import tags from "../store/modules/tags";
import lead_tags from "../store/modules/lead_tags";
import departments from "../store/modules/departments";
import motives from "../store/modules/motives";
import operators from "../store/modules/operators";
import tickets from "../store/modules/tickets";
import histories from "../store/modules/histories";
import campaigns from "../store/modules/campaigns";
import groups from "../store/modules/groups";
import replies from "../store/modules/replies";
import notifications from "../store/modules/notifications";
import logs from "../store/modules/logs";
import bots from "../store/modules/bots";
import chat from "../store/modules/chat";
import notes from "../store/modules/notes";
import wallets from "../store/modules/wallets";
import tasks from "../store/modules/tasks";
import widgets from "../store/modules/widgets";
import templates from "../store/modules/templates";
import dashboard from "../store/modules/dashboard";
import reports from "../store/modules/reports";
import tokens from "../store/modules/tokens";
import conversations from "../store/modules/conversations";
import translations from "../store/modules/translations";
import kanban from "../store/modules/kanban";
import kanban_columns from "../store/modules/kanban_columns";
import kanban_cards from "../store/modules/kanban_cards";
import activities from '../store/modules/activities';
import products from '../store/modules/products';
import product_categories from '../store/modules/product_categories';
import product_brands from '../store/modules/product_brands';
import product_suppliers from '../store/modules/product_suppliers';
import lead_quotes from '../store/modules/lead_quotes';
import categories from '../store/modules/categories';
import lead_requests from './modules/lead_requests';
import gallery from './modules/gallery';
import reports_opportunities from "./modules/reports_opportunities";


Vue.use(Vuex);

export default new Vuex.Store({
    getters: {
      getPublicTranslations: (state, getters, rootState) => (key) => {
        if(window.localStorage.getItem("temp_lang")) {
          // PT_BR
          if (window.localStorage.getItem("temp_lang") == 0) {
            return getters.getTranslationPtBr[`${key}`] !== undefined ? getters.getTranslationPtBr[`${key}`] : '---'
          }
          // EN
          else if (window.localStorage.getItem("temp_lang") == 1) {
            return getters.getTranslationEn[`${key}`] !== undefined ? getters.getTranslationEn[`${key}`] : '---'
          }
          // ES
          else if (window.localStorage.getItem("temp_lang") == 2) {
            return getters.getTranslationEs[`${key}`] !== undefined ? getters.getTranslationEs[`${key}`] : '---'
          }
          // NOT FOUND
          else {
            return '---'
          }
        } else {
          return getters.getTranslationPtBr[`${key}`] !== undefined ? getters.getTranslationPtBr[`${key}`] : '---'
        }
      },
      getTranslations: (state, getters, rootState) => (key) => {
        if(rootState.me.data.id) {
          // PT_BR
          if (rootState.me.data.language_key === 0) {
            return getters.getTranslationPtBr[`${key}`] !== undefined ? getters.getTranslationPtBr[`${key}`] : '---'
          }
          // EN
          else if (rootState.me.data.language_key === 1) {
            return getters.getTranslationEn[`${key}`] !== undefined ? getters.getTranslationEn[`${key}`] : '---'
          }
          // ES
          else if (rootState.me.data.language_key === 2) {
            return getters.getTranslationEs[`${key}`] !== undefined ? getters.getTranslationEs[`${key}`] : '---'
          }
          // NOT FOUND
          else {
            return '---'
          }
        } else {
          return getters.getTranslationPtBr[`${key}`] !== undefined ? getters.getTranslationPtBr[`${key}`] : '---'
        }
      },
    },
    modules: {
      baileys_integration,
      me,
      configs,
      users,
      channels,
      customfield,
      leads,
      interests,
      tags,
      lead_tags,
      departments,
      motives,
      operators,
      tickets,
      histories,
      campaigns,
      replies,
      notifications,
      logs,
      bots,
      chat,
      notes,
      wallets,
      tasks,
      widgets,
      templates,
      dashboard,
      reports,
      tokens,
      conversations,
      translations,
      groups,
      kanban,
      kanban_columns,
      kanban_cards,
      activities,
      products,
      product_categories,
      product_brands,
      product_suppliers,
      categories,
      lead_requests,
      lead_quotes,
      gallery,
      reports_opportunities
    }
})
